module.exports = __webpack_public_path__ + "img/luz.61c98657.svg";